// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rg00","content":"styles_content__1Dg9o"};